module.exports = __webpack_public_path__ + "img/facedrive-foods-logo-icon.097b9a49.png";